import { render } from "./ToggleInput.vue?vue&type=template&id=ff96dd2a&scoped=true"
import script from "./ToggleInput.vue?vue&type=script&lang=js"
export * from "./ToggleInput.vue?vue&type=script&lang=js"

import "./ToggleInput.vue?vue&type=style&index=0&id=ff96dd2a&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff96dd2a"]])

export default __exports__